import { render, staticRenderFns } from "./TeacherCountCard.vue?vue&type=template&id=20346b15&scoped=true&"
import script from "./TeacherCountCard.vue?vue&type=script&lang=js&"
export * from "./TeacherCountCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20346b15",
  null
  
)

export default component.exports